<template>
  <div v-loading="loading" id="stock-list">
    <form class="row search-pannel" :class="{ fold: fold}" @submit.prevent="doLoad(true)">
      <input type="submit" style="display:none" />
      <div class="col-sm-6">
        <el-select size="small" v-model="query.shopId" placeholder="库存门店" clearable>
          <el-option v-for="shop in shops" :label="shop.name" :value="shop.id" :key="shop.id"></el-option>
        </el-select>
      </div>
      <div class="col-sm-6">
        <el-select size="small" v-model="query.brand" placeholder="配件品牌" clearable>
          <el-option v-for="b in orderBrands" :label="b.name" :value="b.code" :key="b.code" />
        </el-select>
      </div>
      <div class="col-sm-6">
        <el-input size="small" v-model="query.partCode" placeholder="配件编号/配件名称" />
      </div>
      <div class="col-sm-6 folder">
        <el-button type="primary" size="small" @click="doLoad(true)">确定</el-button>
        <el-button type="default" size="small" @click="doReset">重置</el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">
          {{ fold ? '展开' : '收起' }}
          <i v-if="fold" class="crm-icon-arrow-down" />
          <i v-else class="crm-icon-arrow-up" />
        </el-button>
      </div>
    </form>
    <div class="data-header">
      <div class="row" :style="{ paddingRight: hasScroll ? 10 + scrollBarWidth + 'px' : 'px' }">
        <div class="col-sm-2">品牌</div>
        <div class="col-sm-4">编号</div>
        <div class="col-sm-4">名称</div>
        <div class="col-sm-2">门店</div>
        <div class="col-sm-2">4S进价</div>
        <div class="col-sm-2">库存</div>
        <div class="col-sm-2">需求</div>
        <div class="col-sm-4">更新时间</div>
        <div class="col-sm-2">上架商品</div>
      </div>
    </div>
    <div ref="dataList" class="data-list">
      <template v-if="list && list.length">
        <div v-for="item in list" :key="item.id" class="stock-item-wraper">
          <div class="stock-item row">
            <div class="col-sm-2">
              <label>品牌</label>
              <div>
                {{ item.brandName }}
              </div>
            </div>
            <div class="col-sm-4">
              <label>编号</label>
              <div>{{ item.partCode }}</div>
            </div>
            <div class="col-sm-4">
              <label>名称</label>
              <div>{{ item.partName }}</div>
            </div>
            <div class="col-sm-2">
              <label>门店</label>
              <div>{{ item.shopName }}</div>
            </div>
            <div class="col-sm-2">
              <label>4S进价</label>
              <div>
                {{ item.cost4s | currencyFmt }}
              </div>
            </div>
            <div class="col-sm-2">
              <label>库存</label>
              <div>{{ item.quantity }}</div>
            </div>
            <div class="col-sm-2">
              <label>需求</label>
              <div>{{ item.quantityRequiring }}</div>
            </div>
            <div class="col-sm-4">
              <label>更新时间</label>
              <div>{{ item.lastUpdateTime }}</div>
            </div>
            <div class="col-sm-2">
              <label>上架商品</label>
              <div v-if="item.shelfCount">
                {{ item.shelfCount }}
                <template>
                  <span v-if="item.shelfTaxPrice > 0" style="color:#6c6c6c;">
                    (含税：{{ item.shelfTaxPrice | currencyFmt }})
                  </span>
                  <span v-else style="color:#6c6c6c;">
                    (税前：{{ item.shelfPretaxPrice | currencyFmt }})
                  </span>
                </template>
              </div>
              <div v-else>--</div>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="no-data">
        暂无数据~
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size="pagination.pageSize"
        @current-change="doLoad(false)"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { ListStock } from './services'
import { bind, unbind } from '@/utils/eventBinder.js'
import _ from 'lodash'
export default {
  name: 'StockPage',
  data () {
    return {
      loading: false,
      fold: true,
      hasScroll: false,
      list: [],
      query: {
        brand: undefined,
        partCode: undefined,
        shopId: undefined
      },
      pagination: {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
    }
  },
  computed: {
    renderRow () {
      return this.list.length
    },
    scrollBarWidth () {
      return this.$store.state.scrollbarWidth
    },
    orderBrands () {
      return this.$store.state.orderBrands || []
    },
    shops () {
      return this.$store.state.shops || []
    }
  },
  watch: {
    renderRow () {
      this.$nextTick(() => {
        this.checkScrollbar()
      })
    }
  },
  async beforeMount () {
    if (!this.orderBrands.length) {
      await this.$store.dispatch('loadOrderBrands')
    }
  },
  mounted () {
    this.checkScrollBarDebounce = _.debounce(() => {
      this.checkScrollbar()
    }, 50)
    bind(window, 'resize', this.checkScrollBarDebounce)
    this.doLoad(true)
  },
  beforeDestory () {
    unbind(window, 'resize', this.checkScrollBarDebounce)
  },
  methods: {
    doLoad (reload) {
      if (reload) {
        this.pagination.pageIndex = 1
      }
      this.loading = true
      const { brand, partCode, shopId } = this.query
      const { pageIndex, pageSize } = this.pagination
      ListStock({
        brandCode: brand || undefined,
        partCode: partCode || undefined,
        shopId: shopId || undefined,
        pageIndex,
        pageSize
      }).then(resp => {
        const { items, pagination } = resp
        this.list = items
        this.pagination = pagination
      }).finally(() => {
        this.loading = false
      })
    },
    doReset () {
      this.query = {
        brand: undefined,
        shopId: undefined,
        partCode: undefined
      }
      this.pagination = {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
      this.doLoad(true)
    },
    checkScrollbar () {
      const dataList = this.$refs.dataList
      if (dataList) {
        this.hasScroll = dataList.clientHeight < dataList.scrollHeight
      } else {
        this.hasScroll = false
      }
    }
  }
}
</script>
